import { IntercomWidgetVariant } from "../const";
import buttonElite from "../res/elite/button@2x.png";
import buttonModern from "../res/modern/button@2x.png";
import buttonSimple from "../res/simple/button@2x.png";
// eslint-disable-next-line import/order
import { PropsWithChildren } from "react";
import { cn } from "@/core/helpers/cn";

type KeypadButtonProps = PropsWithChildren<{
  variant: IntercomWidgetVariant;
  onClick: () => void;
}>;

const variants = {
  [IntercomWidgetVariant.Simple]: {
    image: buttonSimple,
    size: 56,
  },
  [IntercomWidgetVariant.Modern]: {
    image: buttonModern,
    size: 56,
  },
  [IntercomWidgetVariant.Elite]: {
    image: buttonElite,
    size: 50,
  },
};

export function KeypadButton({ children, variant, onClick }: KeypadButtonProps) {
  const { image, size } = variants[variant];

  return (
    <button
      type="button"
      className={cn("relative mx-auto shrink-0 transition-transform duration-100 active:scale-95")}
      style={{ width: size, height: size }}
      onClick={onClick}
    >
      <img src={image} alt="" className="size-full" />
      <div className="top-1/2 left-1/2 absolute font-semibold text-[#323232] text-26 text-center -translate-x-1/2 -translate-y-1/2">
        {children}
      </div>
    </button>
  );
}
